import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const CateSubmenuItem = styled.li<IProps>`
  & {
    > .btn {
      ${mixin.flex({ justify: 'flex-start' })};
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
      padding: 16px 20px;
      color: #777;
      text-align: left;
    }

    &.active {
      > .btn {
        color: #000;
      }

      .btn {
        background-color: #fff;
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    & {
      > .btn {
        font-size: ${mixin.pxToVw('14')};
        padding: ${mixin.pxToVw('16 20')};
      }
    }
  }
`;
